export default __webpack_public_path__ + "static/media/IMG_6330.7d55b434.JPG";